<div class="ReferralRegistrationThankYou container mb-3">
  <div class="ReferralRegistrationThankYou-header text-center">
    <h3>Thank you</h3>
    <p>Your referral partner registration has been submitted successfully.</p>
  </div>

  <div *ngIf="hasSummary; else emptySummary" class="ReferralRegistrationThankYou-summary">
    <h4>Submission Summary</h4>

    <div class="ReferralRegistrationThankYou-summary-row" *ngFor="let item of summaryItems">
      <span class="ReferralRegistrationThankYou-summary-label">{{ item.label }}</span>
      <span class="ReferralRegistrationThankYou-summary-value">{{ item.value }}</span>
    </div>
  </div>

  <ng-template #emptySummary>
    <div class="ReferralRegistrationThankYou-empty">
      <p>Your details were submitted. This page will be expanded soon.</p>
    </div>
  </ng-template>
</div>
